import { NgModule } from '@angular/core';
import { I18nConfig, provideConfig } from '@spartacus/core';
import { storeFinderTranslationChunksConfig } from '@spartacus/storefinder/assets';
import { StoreFinderRootModule } from '@spartacus/storefinder/root';

@NgModule({
  declarations: [],
  imports: [StoreFinderRootModule],
  providers: [
    provideConfig(<I18nConfig>{
      i18n: {
        backend: { loadPath: '/translations/{{lng}}/{{ns}}.json' },
        chunks: storeFinderTranslationChunksConfig
      }
    })
  ]
})
export class StoreFinderFeatureModule {}
